import React, { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import { Link } from "react-router";
import LeadQuickView from "./popup";
import Tooltip from "../../../../component/ui/tooltip";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../../component/table/table-layout";
import StatusChip from "../../../../component/ui/chip/status";
import NewEyeIcon from "../../../../component/icons/action-eye-icon";
import NewCardIcon from "../../../../component/icons/action-card-icon";

const OrgRecycledLeadList = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [brands, setBrands] = useState([]);
  const [products, setProducts] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);
  const [empPopup, setEmpPopup] = useState(false);
  const [viewType, setViewType] = useState("list");
  const [empData, setEmpData] = useState({});
  const [PackageList, setPackageList] = useState([]);
  const [DealStages, setDealStages] = useState([]);

  const [total, setTotal] = useState([]);

  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);

  const [pageCount, setPageCount] = useState(1);
  const [pageItemsCount, setPageItemsCount] = useState(10);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
  }, []);

  const getData = async ({
    filter = filterReturn,
    page,
    page_quantity = pageItemsCount,
  }) => {
    if (!page) {
      setIsLoading(true);
    }
    let apiData = { page: page, page_quantity: 10 };
    let extraUrl = `&page=${page || 1}&page_quantity=${page_quantity}`;
    for (let i = 0; i < filter?.length; i++) {
      extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
    }

    try {
      const res = await apiCall({
        method: "get",
        url: `leads/recycle-queue-leads-list?view=organization${extraUrl}`,
        data: apiData,
      });
      if (page) {
        setApiData((prev) => [...prev, ...res.data]);
      } else {
        setApiData(res.data);
      }

      setTableHeader(res?.applied_headers);
      setSaveFilter(res?.custom_filters);
      setTablePagination(res?.pagination);
      setTotal(res?.pagination?.total);

      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const tableRef = useRef(null);

  return (
    <>
      <div className={`${Style.mainBody} `}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>
              {/* HEADER */}
              <div className={Style.empDirectory_header}>
                <div className={Style.empDirectory_header_left}>
                  {viewType === "list" ? (
                    <div className={Style.bpfl_select}>
                      <select
                        onChange={(e) => {
                          getData({ page_quantity: e?.target.value });
                          setPageCount(1);
                          setPageItemsCount(e?.target.value);
                        }}
                      >
                        <option value="10">Recycled Leads View 10</option>
                        <option value="25">Recycled Leads View 25</option>
                        <option value="50">Recycled Leads View 50</option>
                        <option value="100">Recycled Leads View 100</option>
                        <option value={total}>Recycled Leads View all</option>
                      </select>
                    </div>
                  ) : (
                    <div className="text-xl font-bold pl-3 flex items-center gap-1 leading-10 ">
                      Organization Lead Pipeline
                    </div>
                  )}
                </div>
                <div className={Style.empDirectory_header_right}>
                  <div className={Style.bpfl_action}>
                    <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"Customize Table"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${
                          viewType === "kanban" ? Style.disabled : ""
                        }`}
                        onClick={() => {
                          setShowModalCustomizeTabs(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <LayoutTopIcon />
                        </div>
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>

              {/* BODY */}
              <div className={Style.empDirectory_body}>
                {isLoading ? (
                  <InnerLoader />
                ) : !apiData?.length ? (
                  <div className="flex justify-center items-center w-full h-full">
                    <DataNotFound title={"recycled leads"} />
                  </div>
                ) : (
                  <>
                    <TableCard ref={tableRef}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell header sticky>
                              <TableHeaderWrap>
                                <span className="pl-[50px]">Name</span>
                              </TableHeaderWrap>
                            </TableCell>
                            {tableHeader?.map((eachHead, index) =>
                              eachHead.is_visible === 1 &&
                              eachHead?.show == 1 ? (
                                <TableCell header key={index}>
                                  <TableHeaderWrap>
                                    <span>{eachHead?.value}</span>
                                  </TableHeaderWrap>
                                </TableCell>
                              ) : null
                            )}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {apiData?.map((eachList, index) => {
                            return (
                              <TableRow key={`${index}`}>
                                <TableCell sticky>
                                  <div
                                    className={`${Style.tableActionArea} !gap-4`}
                                  >
                                    <div className="flex gap-2 items-center">
                                      <div className="flex items-center gap-3">
                                        <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium object-cover object-center">
                                          {eachList?.userimg ? (
                                            <img
                                              className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium object-cover object-center"
                                              src={eachList?.userimg}
                                              alt={eachList?.name}
                                              onError={(e) => {
                                                e.target.classList.add(
                                                  "hidden"
                                                );
                                                if (e.target.parentElement) {
                                                  e.target.parentElement.innerHTML = `
                              <div class="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                ${eachList?.name?.split(" ")[0]?.[0] || ""}${
                                                    eachList?.name?.split(
                                                      " "
                                                    )[1]?.[0] || ""
                                                  }
                              </div>`;
                                                }
                                              }}
                                            />
                                          ) : (
                                            <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                              {eachList?.name?.split(" ")[0]
                                                ? eachList?.name?.split(
                                                    " "
                                                  )[0][0]
                                                : ""}
                                              {eachList?.name?.split(" ")[1]
                                                ? eachList?.name?.split(
                                                    " "
                                                  )[1][0]
                                                : ""}
                                            </div>
                                          )}
                                        </div>

                                        <div className="font-medium leading-5">
                                          {eachList?.name}
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      className={Style.tableActionAreaBtnGrpup}
                                    >
                                      <div
                                        className={
                                          "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                        }
                                        onClick={() => {
                                          setEmpPopup(true);
                                          setEmpData(eachList);
                                        }}
                                      >
                                        <div
                                          className={Style.icon}
                                          style={{ color: "#007AFF" }}
                                        >
                                          <NewEyeIcon className="h-4.5 w-4.5" />
                                        </div>
                                      </div>

                                      {eachList?.leadid ? (
                                        <Link
                                          to={`/leads/leadDetail/${eachList?.leadid}`}
                                          className={
                                            "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                          }
                                        >
                                          <div
                                            className={Style.icon}
                                            style={{ color: "#34C759" }}
                                          >
                                            <NewCardIcon className="h-4.5 w-4.5" />
                                          </div>
                                        </Link>
                                      ) : eachList?.userid ? (
                                        <Link
                                          to={`/contacts/contact-details/${eachList?.userid}`}
                                          className={
                                            "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                          }
                                        >
                                          <div
                                            className={Style.icon}
                                            style={{ color: "#34C759" }}
                                          >
                                            <NewCardIcon className="h-4.5 w-4.5" />
                                          </div>
                                        </Link>
                                      ) : null}
                                    </div>
                                  </div>
                                </TableCell>
                                {tableHeader?.map((eachHead, i) =>
                                  eachHead.is_visible === 1 &&
                                  eachHead?.show == 1 ? (
                                    <>
                                      {eachHead.key === "leadtype" ? (
                                        <TableCell
                                          key={`${i}-${index}`}
                                          className="text-center capitalize"
                                        >
                                          {eachList[eachHead.key] ===
                                          "unpaid" ? (
                                            <StatusChip color="red">
                                              {eachList[eachHead.key] || "--"}
                                            </StatusChip>
                                          ) : (
                                            <StatusChip color="green">
                                              {eachList[eachHead.key] || "--"}
                                            </StatusChip>
                                          )}
                                        </TableCell>
                                      ) : eachHead.key == "email" ? (
                                        <TableCell key={`td-${i}`}>
                                          {eachList[eachHead?.key] ? (
                                            <a
                                              href={
                                                `mailto:${
                                                  eachList[eachHead?.key]
                                                }` || ""
                                              }
                                            >
                                              {eachList[eachHead?.key] || "--"}
                                            </a>
                                          ) : (
                                            "--"
                                          )}
                                        </TableCell>
                                      ) : eachHead.key === "leadstatus" ? (
                                        <TableCell
                                          key={`${i}-${index}`}
                                          className="text-center capitalize"
                                        >
                                          {eachList.leadstatus ? (
                                            <StatusChip
                                              color={
                                                eachList.leadstatus ===
                                                "Pending"
                                                  ? "blue"
                                                  : "green"
                                              }
                                            >
                                              {eachList[eachHead.key] || "--"}
                                            </StatusChip>
                                          ) : (
                                            "-"
                                          )}
                                        </TableCell>
                                      ) : eachHead.key === "last_comment" ? (
                                        <TableCell key={`${i}-${index}`}>
                                          {eachList?.last_comment?.comment ??
                                            "-"}
                                        </TableCell>
                                      ) : eachHead.key === "assigned" ? (
                                        <TableCell key={`${i}-${index}`}>
                                          <div className="flex">
                                            {Array.isArray(
                                              eachList?.assigned
                                            ) &&
                                            eachList.assigned.length > 0 ? (
                                              eachList.assigned.map(
                                                (user, idx) => (
                                                  <Tooltip
                                                    key={idx}
                                                    content={user.name}
                                                    position="top center"
                                                  >
                                                    <div
                                                      className={`relative ${
                                                        idx !== 0 ? "-ml-2" : ""
                                                      }`}
                                                    >
                                                      {user?.userimg ? (
                                                        <img
                                                          src={user.userimg}
                                                          alt={user.name}
                                                          className="h-8 w-8 rounded-full border-2 border-white object-cover object-center shadow-sm bg-white"
                                                          onError={(e) => {
                                                            e.target.onerror =
                                                              null;
                                                            e.target.style.display =
                                                              "none";
                                                            const fallback =
                                                              document.createElement(
                                                                "div"
                                                              );
                                                            fallback.className =
                                                              "h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm";
                                                            fallback.innerText =
                                                              (
                                                                (user?.name?.split(
                                                                  " "
                                                                )[0]?.[0] ||
                                                                  "") +
                                                                (user?.name?.split(
                                                                  " "
                                                                )[1]?.[0] || "")
                                                              ).toUpperCase();
                                                            e.target.parentElement.appendChild(
                                                              fallback
                                                            );
                                                          }}
                                                        />
                                                      ) : (
                                                        <div className="h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm">
                                                          {(user?.name?.split(
                                                            " "
                                                          )[0]?.[0] || "") +
                                                            (user?.name?.split(
                                                              " "
                                                            )[1]?.[0] || "")}
                                                        </div>
                                                      )}
                                                    </div>
                                                  </Tooltip>
                                                )
                                              )
                                            ) : (
                                              <span className="text-gray-400 text-sm">
                                                -
                                              </span>
                                            )}
                                          </div>
                                        </TableCell>
                                      ) : (
                                        <TableCell key={`${i}-${index}`}>
                                          {eachList[eachHead.key] ?? "-"}
                                        </TableCell>
                                      )}
                                    </>
                                  ) : null
                                )}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableCard>
                  </>
                )}
              </div>

              {!isLoading ? (
                apiData?.length > 0 ? (
                  <div
                    className={Style.table_footer}
                    style={{ alignItems: "center" }}
                  >
                    <div className={Style.table_footer_left}>
                      {`showing 1 to ${apiData?.length} of ${
                        tablePagination?.total || apiData?.length
                      }`}
                    </div>

                    {tablePagination ? (
                      <div className={Style.empDirectory_footer}>
                        {tablePagination?.next_page_url ? (
                          <button
                            className={Style.loadMoreBtn}
                            onClick={() => {
                              if (btnLoader) return;
                              // setPageCount(pageCount + 1);
                              setBtnLoader(true);
                              // filterData({ page: pageCount + 1, btnCall: true });
                              getData({
                                page: tablePagination?.next_page_url,
                              });
                            }}
                          >
                            {btnLoader ? (
                              <InnerLoader
                                className={Style.loader}
                                textStatus={false}
                              />
                            ) : (
                              "Load More"
                            )}
                          </button>
                        ) : null}
                      </div>
                    ) : null}

                    <div
                      className={`${Style.table_footer_left} ${Style.rightText}`}
                    ></div>
                  </div>
                ) : null
              ) : (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  <div className={Style.table_footer_left}>
                    <Skeleton width={"50%"} height={15} />
                  </div>

                  <div className={Style.empDirectory_footer}>
                    <Skeleton width={"180px"} height={40} />
                  </div>

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeader}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeader(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeader(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="leads/recycle-queue-leads-list"
        />
      )}

      {empPopup && empData?.leadid && (
        <LeadQuickView
          onClose={() => {
            setEmpPopup(false);
            setEmpData({});
          }}
          data={empData}
          ProductList={products}
          PackageList={PackageList}
          DealStages={DealStages}
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default OrgRecycledLeadList;
